import { connect } from "react-redux";

import SessionExpirationMessage from './SessionExpirationMessage';

const mapStateToProps = state => ({
  displaySessionTimeoutMessage: state.session.displaySessionTimeoutMessage
});

export default connect(mapStateToProps)(SessionExpirationMessage);
